import React, { useState } from "react";

function ImageSliderButton({ text, isVisible, onClick }: any) {
  return (
    <button
      className="flex-none focus:outline-none disabled:opacity-25"
      onClick={onClick}
      disabled={!isVisible}
    >
      {text}
    </button>
  );
}

function ImageSlider({ imageUrls }: any) {
  const [current, setCurrent] = useState(0);
  console.log(imageUrls);
  return (
    <div className="flex justify-center p-4">
      <div className="">
        <div className="mx-auto justify-center">
          <img
            className="mx-auto"
            alt={imageUrls[current].altText}
            src={`http://imgresizr.tk/?url=${imageUrls[current].url}&width=1200&height=600&quality=75`}
          />
        </div>
        <div className="mx-auto flex gap-2 justify-center">
          <ImageSliderButton
            isVisible={current > 0 ? true : false}
            onClick={() => {
              if (current > 0) {
                setCurrent(current - 1);
              }
            }}
            text={
              <svg
                className="w-6 h-6 hover:ring-purple-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M7 16l-4-4m0 0l4-4m-4 4h18"
                ></path>
              </svg>
            }
          />
          <p className="italic flex-1 text-center ">{`${imageUrls[current].caption} Credit : ${imageUrls[current].credit}`}</p>
          <ImageSliderButton
            isVisible={current === imageUrls.length - 1 ? false : true}
            onClick={() => {
              if (current < imageUrls.length - 1) {
                setCurrent(current + 1);
              }
            }}
            text={
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M17 8l4 4m0 0l-4 4m4-4H3"
                ></path>
              </svg>
            }
          />
        </div>
      </div>
    </div>
  );
}

export default ImageSlider;
